import { Link } from "react-router-dom";
import type { Topic } from "@/mocks/topics";
import TopicCard from "@/components/feature/TopicCard";

interface FeaturedSectionProps {
  topics: Topic[];
}

export default function FeaturedSection({ topics }: FeaturedSectionProps) {
  return (
    <section className="bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-7xl px-4 md:px-8">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="text-xs font-medium tracking-[0.3em] text-primary-600">
              EDITOR'S PICK
            </span>
            <h2 className="mt-4 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              编辑精选 · 值得完整读完的档案
            </h2>
          </div>
          <Link
            to="/topics"
            className="inline-flex items-center gap-2 whitespace-nowrap text-sm font-medium text-foreground-700 transition-colors hover:text-primary-600"
          >
            全部专题
            <i className="ri-arrow-right-line" />
          </Link>
        </div>

        <div className="mt-8 divide-y divide-background-200 border-t border-background-200">
          {topics.map((topic, index) => (
            <TopicCard key={topic.id} topic={topic} variant="horizontal" rank={index + 1} />
          ))}
        </div>
      </div>
    </section>
  );
}